export const appName = "TrueTMS";
export const companyName = "T3 Tech";
